/**
 * Mysa Miami — optional motion layer.
 *
 * Paired with mysa-motion.css. Both are loaded only when the "Extra motion"
 * theme setting is on, and every effect is self-contained: nothing here is
 * required by the rest of the theme, so removing the setting (or the two
 * files) restores the previous behaviour exactly.
 *
 * Guards applied throughout:
 *   - bails out entirely under prefers-reduced-motion
 *   - only animates transform/opacity, to stay off the layout path
 *   - all listeners are passive where they can be
 *   - every effect no-ops if its markup isn't on the page
 */
(function () {
  'use strict';

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var EASE = 'cubic-bezier(0.22, 0.61, 0.36, 1)';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------------------------------------------------------------- flight */

  function cartIcon() {
    return $('.cart-link') || $('.js-drawer-open-cart') || $('.site-header__cart');
  }

  function flyToCart(sourceImg) {
    var target = cartIcon();
    if (!sourceImg || !target || !sourceImg.src) return;

    var from = sourceImg.getBoundingClientRect();
    var to = target.getBoundingClientRect();
    if (!from.width || !to.width) return;

    var clone = document.createElement('img');
    clone.src = sourceImg.currentSrc || sourceImg.src;
    clone.className = 'mysa-fly';
    clone.setAttribute('aria-hidden', 'true');
    clone.style.left = from.left + 'px';
    clone.style.top = from.top + 'px';
    clone.style.width = from.width + 'px';
    clone.style.height = from.height + 'px';
    document.body.appendChild(clone);

    var dx = to.left + to.width / 2 - (from.left + from.width / 2);
    var dy = to.top + to.height / 2 - (from.top + from.height / 2);

    var anim = clone.animate(
      [
        { transform: 'translate(0,0) scale(1)', opacity: 1 },
        { transform: 'translate(' + dx * 0.55 + 'px,' + (dy * 0.25 - 60) + 'px) scale(0.55)', opacity: 0.9, offset: 0.55 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(0.06)', opacity: 0.25 }
      ],
      { duration: 850, easing: EASE, fill: 'forwards' }
    );

    anim.onfinish = function () {
      clone.remove();
      target.classList.add('mysa-bag-pop');
      setTimeout(function () { target.classList.remove('mysa-bag-pop'); }, 600);
    };
  }

  function initFlight() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.add-to-cart');
      if (!btn || btn.hasAttribute('disabled')) return;

      var scope = btn.closest('.product-section') || document;
      var img =
        $('.product-single__photo img', scope) ||
        $('.product__main-photos img', scope) ||
        $('.product__photos img', scope);

      // let the form submit first; the clone is purely decorative
      setTimeout(function () { flyToCart(img); }, 0);
    });
  }

  /* --------------------------------------------------------------- buy bar */

  function initBuyBar() {
    var atc = $('.add-to-cart');
    if (!atc || !$('.product-section')) return;

    var title = $('.product-single__title');
    var price = $('.product-block--price .product__price') || $('.product__price');
    var img = $('.product-single__photo img') || $('.product__main-photos img');
    if (!title) return;

    var bar = document.createElement('div');
    bar.className = 'mysa-buybar';
    bar.innerHTML =
      (img ? '<img class="mysa-buybar__thumb" src="' + (img.currentSrc || img.src) + '" alt="">' : '') +
      '<span class="mysa-buybar__text">' +
      '<span class="mysa-buybar__title"></span>' +
      '<span class="mysa-buybar__price"></span>' +
      '</span>' +
      '<button type="button" class="btn mysa-buybar__btn">Add to cart</button>';
    bar.querySelector('.mysa-buybar__title').textContent = title.textContent.trim();
    if (price) bar.querySelector('.mysa-buybar__price').textContent = price.textContent.trim();
    document.body.appendChild(bar);

    bar.querySelector('.mysa-buybar__btn').addEventListener('click', function () {
      atc.click();
    });

    var footer = $('.site-footer');
    var queued = false;
    function update() {
      queued = false;
      var r = atc.getBoundingClientRect();
      // Show for the whole page below the real button — the point of a sticky
      // bar is being able to buy from the recommendations, not just the buy box.
      var show = r.bottom < 0;
      // but stand down over the footer so it doesn't sit on top of the links
      if (show && footer) {
        var f = footer.getBoundingClientRect();
        if (f.top < window.innerHeight * 0.75) show = false;
      }
      if (atc.hasAttribute('disabled')) show = false;
      bar.classList.toggle('is-visible', show);
    }
    // setTimeout rather than rAF: this only toggles a class, and rAF is paused
    // while a tab is hidden, which would leave the bar in a stale state.
    function onScroll() {
      if (queued) return;
      queued = true;
      window.setTimeout(update, 60);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  /* ------------------------------------------------------ variant crossfade */

  function initVariantFade() {
    var img = $('.product-single__photo img') || $('.product__main-photos img');
    if (!img) return;

    var last = img.getAttribute('src');
    var obs = new MutationObserver(function () {
      var now = img.getAttribute('src');
      if (now === last) return;
      last = now;
      img.classList.add('mysa-variant-fade');
      // one frame for the new source to decode, then fade back in
      if (img.decode) {
        img.decode().catch(function () {}).then(function () {
          img.classList.remove('mysa-variant-fade');
        });
      } else {
        setTimeout(function () { img.classList.remove('mysa-variant-fade'); }, 120);
      }
    });
    obs.observe(img, { attributes: true, attributeFilter: ['src', 'srcset'] });
  }

  /* ------------------------------------------------------- magnetic buttons */

  function initMagnetic() {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    var SEL = '.mysa-btn, .add-to-cart, .grid__item.text-center > .btn, .mysa-marquee__cta .btn';
    var STRENGTH = 0.32;
    var MAX = 10;

    document.addEventListener('pointermove', function (e) {
      var btn = e.target.closest && e.target.closest(SEL);
      if (!btn) return;
      btn.classList.add('mysa-magnetic', 'is-pulled');
      var r = btn.getBoundingClientRect();
      var dx = (e.clientX - (r.left + r.width / 2)) * STRENGTH;
      var dy = (e.clientY - (r.top + r.height / 2)) * STRENGTH;
      btn.style.setProperty('--mx', Math.max(-MAX, Math.min(MAX, dx)).toFixed(1) + 'px');
      btn.style.setProperty('--my', Math.max(-MAX, Math.min(MAX, dy)).toFixed(1) + 'px');
    }, { passive: true });

    document.addEventListener('pointerout', function (e) {
      var btn = e.target.closest && e.target.closest(SEL);
      if (!btn) return;
      btn.classList.remove('is-pulled');
      btn.style.removeProperty('--mx');
      btn.style.removeProperty('--my');
    }, { passive: true });
  }

  /* ------------------------------------------------------ tile cursor label */

  function initTileCursor() {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    $$('.mysa-tile').forEach(function (tile) {
      var label = tile.querySelector('.mysa-btn');
      var text = label ? label.textContent.trim() : 'Shop';

      var dot = document.createElement('span');
      dot.className = 'mysa-tile__cursor';
      dot.setAttribute('aria-hidden', 'true');
      dot.textContent = text;
      tile.appendChild(dot);

      var raf = null, x = 0, y = 0;
      function place() {
        raf = null;
        dot.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0)' +
          (dot.classList.contains('is-visible') ? ' scale(1)' : ' scale(0.4)');
      }

      tile.addEventListener('pointerenter', function () { dot.classList.add('is-visible'); }, { passive: true });
      tile.addEventListener('pointerleave', function () { dot.classList.remove('is-visible'); }, { passive: true });
      tile.addEventListener('pointermove', function (e) {
        var r = tile.getBoundingClientRect();
        x = e.clientX - r.left;
        y = e.clientY - r.top;
        if (!raf) raf = window.requestAnimationFrame(place);
      }, { passive: true });
    });
  }

  /* ---------------------------------------------------- scroll-velocity skew */

  function initMarqueeVelocity() {
    var tracks = $$('.mysa-marquee__track');
    if (!tracks.length) return;

    var lastY = window.scrollY, lastT = performance.now(), raf = null;

    function settle() {
      raf = null;
      tracks.forEach(function (t) { t.style.setProperty('--mysa-skew', '0deg'); });
    }

    window.addEventListener('scroll', function () {
      var now = performance.now();
      var dt = Math.max(16, now - lastT);
      var v = (window.scrollY - lastY) / dt; // px per ms
      lastY = window.scrollY;
      lastT = now;

      var skew = Math.max(-6, Math.min(6, v * 2.4));
      tracks.forEach(function (t) { t.style.setProperty('--mysa-skew', skew.toFixed(2) + 'deg'); });

      if (raf) clearTimeout(raf);
      raf = setTimeout(settle, 140);
    }, { passive: true });
  }

  /* --------------------------------------------------------- heading reveal */

  function initHeadingMask() {
    var SEL = '.section-header__title, .mysa-story__heading, .mysa-track__heading, .mysa-tile__heading';
    var heads = $$(SEL).filter(function (h) { return !h.querySelector('.mysa-mask'); });
    if (!heads.length) return;

    heads.forEach(function (h) {
      // wrap each <br>-separated line so they can stagger
      var parts = h.innerHTML.split(/<br\s*\/?>/i);
      h.innerHTML = parts
        .map(function (p, i) {
          return '<span class="mysa-mask" style="transition-delay:' + i * 110 + 'ms">' + p + '</span>';
        })
        .join('<br>');
    });

    var masks = $$('.mysa-mask');
    var pending = masks.slice();

    function check() {
      var limit = window.innerHeight * 0.9;
      pending = pending.filter(function (m) {
        var r = m.getBoundingClientRect();
        if (r.top < limit && r.bottom > 0) { m.classList.add('is-revealed'); return false; }
        return true;
      });
      if (!pending.length) window.removeEventListener('scroll', onScroll);
    }
    var queued = false;
    function onScroll() {
      if (queued) return;
      queued = true;
      setTimeout(function () { queued = false; check(); }, 60);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    check();
  }

  /* --------------------------------------------------------------- parallax */

  function initParallax() {
    var media = $('.mysa-story__media');
    var img = $('.mysa-story__img');
    if (!media || !img) return;

    var ticking = false;
    function update() {
      ticking = false;
      var r = media.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      // -1 (below fold) .. 1 (above), scaled to a gentle drift
      var progress = (r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight;
      img.style.setProperty('--mysa-parallax', (progress * -38).toFixed(1) + 'px');
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  /* ------------------------------------------------------------------- boot */

  function init() {
    initFlight();
    initBuyBar();
    initVariantFade();
    initMagnetic();
    initTileCursor();
    initMarqueeVelocity();
    initHeadingMask();
    initParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
